import PropTypes from "prop-types";
import React from "react";
import { Card, List, Typography, Divider } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import ResourceListItem from "./ResourceListItem";

const useStyles = makeStyles(theme => ({
  card: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(4, 5),
    "&:hover > h6  $iconButton": {
      opacity: 1
    }
  },
  title: {
    marginBottom: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  listItemContainer: {
    "&:hover $iconButton": {
      opacity: 1
    }
  },
  list: {
    minHeight: theme.spacing(1),
    padding: theme.spacing(2, 0, 2, 0)
  }
}));

const Resource = ({ section, onItemClick, sectionRefs }) => {
  const classes = useStyles();

  const listItem = (item, index) => {
    return (
      <div ref={sectionRefs[section.id]} key={index}>
        <ResourceListItem
          item={item}
          onClick={() => onItemClick(section.id, item.id)}
        />
        {index !== section.items.length - 1 && <Divider />}
      </div>
    );
  };
  const sectionContent = () => {
    if (section.items && section.items.length > 0) {
      return (
        <List className={classes.list}>
          {section.items.map((item, index) => listItem(item, index))}
        </List>
      );
    }
    return <div />;
  };

  return (
    <Card className={classes.card}>
      <Typography className={classes.title} variant="h6" color="textPrimary">
        {section.name}
      </Typography>
      {sectionContent()}
    </Card>
  );
};

export default Resource;

Resource.propTypes = {
  onItemClick: PropTypes.func,
  section: PropTypes.shape({
    /**
     * The name of the resource section
     */
    name: PropTypes.string,
    /**
     * The resources within the resource section
     */
    items: PropTypes.arrayOf(
      PropTypes.shape({
        /**
         * The name of the resource
         */
        name: PropTypes.string,

        /**
         * The type of the resource
         */
        type: PropTypes.string
      })
    )
  }),
  sectionRefs: PropTypes.array
};
